// utils.ts
import { User, MembershipType } from "@/lib/auth-store" // adjust path if needed
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getMembershipMessage(user?: User) {
  const membership = user?.membership ?? MembershipType.Free;

  switch (membership) {
    case MembershipType.Premium:
      return "Premium Member";
    case MembershipType.VIP:
      return "VIP Member";
    case MembershipType.Free:
    default:
      return "Free Member";
  }
}

export function formatDate(isoDate: string): string {
  const date = new Date(isoDate);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  } as Intl.DateTimeFormatOptions; // cast here

  return date.toLocaleString("en-US", options);
}
